import { render, staticRenderFns } from "./BarcodeTemplate.vue?vue&type=template&id=24413517&scoped=true&"
import script from "./BarcodeTemplate.vue?vue&type=script&lang=js&"
export * from "./BarcodeTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24413517",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24413517')) {
      api.createRecord('24413517', component.options)
    } else {
      api.reload('24413517', component.options)
    }
    module.hot.accept("./BarcodeTemplate.vue?vue&type=template&id=24413517&scoped=true&", function () {
      api.rerender('24413517', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/BarcodeTemplate.vue"
export default component.exports